import { createContext } from "react";
export const EditNoteContext = createContext();
